import { useContext, useEffect, useRef } from "react";
import { TableContext, UserContext, SettingsContext, ShopContext } from "./App";

function Socket({ socket }) {
  const { settings, load_menu, loadCart, loadSettings, onDiscountsProductsEvent, reloadDiscountsAvailability } =
    useContext(SettingsContext);
  const { table, load_table } = useContext(TableContext);
  const { shop } = useContext(ShopContext);
  const { user } = useContext(UserContext);
  const cartRefreshTimerRef = useRef(null);
  const tableRefreshTimerRef = useRef(null);
  const loadCartRef = useRef(loadCart);
  loadCartRef.current = loadCart;

  useEffect(() => {
    console.log("add socket listener");
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("subscribed", onSubrscribed);
    socket.on("events", onSocketEvents);

    if (socket.connected) onConnect();

    return () => {
      console.log("remove socket listener");
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("subscribed", onSubrscribed);
      socket.off("events", onSocketEvents);
    };
  }, [socket, user?.id, table?.id, shop?.id, settings?.mandant?.id]);

  function onConnect() {
    if (!settings?.mandant?.id || !shop?.id || !table?.id) return;
    console.log("Socket connected", socket.id, user?.id);
    let mandantId = settings.mandant.id;
    const hostname = window.location.hostname;
    if (process.env.REACT_APP_API_BASE_URL) mandantId = mandantId + "_localhost";
    if (hostname.includes(".demo.")) mandantId = mandantId + "_demo";

    socket.emit("subscribe", "m" + mandantId + ".settings.#");
    socket.emit("subscribe", "m" + mandantId + ".menu.#");
    socket.emit("subscribe", "m" + mandantId + ".products_stock.#");
    socket.emit("subscribe", "m" + mandantId + ".discounts_products.#");
    socket.emit("subscribe", "m" + mandantId + ".s" + shop.id + ".tables.*." + table.id);
    socket.emit("subscribe", "m" + mandantId + ".self_cart.*." + table.id);
    // riallinea la quantita' residua degli sconti dopo una (ri)connessione: nel frattempo gli eventi possono essersi persi
    if (reloadDiscountsAvailability) reloadDiscountsAvailability();
  }

  function onDisconnect() {
    console.log("Socket disconnected");
  }

  function onSubrscribed(data) {
    console.log(data);
  }

  function scheduleCartRefresh() {
    if (cartRefreshTimerRef.current) return;
    cartRefreshTimerRef.current = setTimeout(() => {
      cartRefreshTimerRef.current = null;
      loadCartRef.current();
    }, 200);
  }

  function scheduleTableRefresh() {
    if (tableRefreshTimerRef.current) return;
    tableRefreshTimerRef.current = setTimeout(() => {
      tableRefreshTimerRef.current = null;
      if (table) load_table(table.id);
    }, 200);
  }

  function onSocketEvents(message) {
    console.log("new socket event: ", message);
    if (message.table == "tables") {
      scheduleTableRefresh();
      scheduleCartRefresh();
    }
    if (message.table == "self_cart") scheduleCartRefresh();
    if (message.table == "menu") load_menu();
    if (message.table == "discounts_products") onDiscountsProductsEvent(message.data);
    if (message.table == "settings") loadSettings();
  }

  return null;
}

export default Socket;
